<template>
  <div class="player">
    <div class="player_header">
      <cl-svg-icon
        width="20"
        height="20"
        icon-class="page_back_white"
        class="mr4"
        @click.native="backPage"
      ></cl-svg-icon>
      <span @click="backPage">球探选材</span>
    </div>
    <div class="player_main">
      <div class="players" v-if="playerList.length">
        <div
          class="player_item"
          v-for="item in playerList"
          :key="item.id"
          @click="clickPlayer(item)"
        >
          <div
            class="player_avatar"
            :style="{ background: colors[Math.floor(Math.random() * 5)] }"
          >
            {{ setAvatar(item.name) }}
          </div>
          <div>
            <div class="name">{{ item.name }}</div>
            <div class="date">{{ item.birthday }}</div>
          </div>
        </div>
      </div>
      <cl-no-data v-else height="calc(100% - 54px)"></cl-no-data>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      playerList: [],
      colors: ["#326A54", "#531B85", "#DC502D", "#D3973B", "#3A5DCC"],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    setAvatar(name) {
      const res = name?.split("")[0];
      return res;
    },
    backPage() {
      this.$router.push("/home-woman");
    },
    clickPlayer(item) {
      console.log(item);
      sessionStorage.setItem("scoutItem", JSON.stringify(item));
      this.$router.push("/scouting-report-details");
    },
    getData() {
      let params = {
        year: this.$route.query.year,
      };
      this.$server.getWoamnScout(params).then((res) => {
        this.playerList = res.data || [];
      });
    },
  },
};
</script>
<style scoped lang="scss">
.player {
  width: 100%;
  height: 100%;
}
.player_header {
  width: 100%;
  height: 115px;
  padding: 12px 24px;
  box-sizing: border-box;
  font-size: 20px;
  color: #fff;
  background-image: url("~@/assets/images/cfa/header_bg.png");
  > span {
    cursor: pointer;
  }
}
.player_main {
  width: 100%;
  height: calc(100% - 94px);
  padding: 0 24px;
  box-sizing: border-box;
}

.players {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow-y: auto;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-top: 24px;
  box-sizing: border-box;
  margin-top: -40px;
  background-color: #fff;
  border-radius: 4px;
  .player_item {
    width: 213px;
    height: 98px;
    margin-right: 16px;
    margin-bottom: 16px;
    background: #326a540f;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .name {
    font-size: 18px;
    margin-bottom: 4px;
    color: #000000;
  }
  .date {
    font-size: 14px;
    font-family: DINRegular;
    opacity: 0.6;
    color: #000000;
  }
  .player_avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #3663e1;
    margin-right: 15px;
    margin-left: 23px;
    color: #fff;
    line-height: 48px;
    text-align: center;
    font-size: 26px;
  }
}
</style>
